import React from 'react';
import {
  FormPageInputItemTextAdditionalText,
  FormPageInputItemTextMultiLine,
  FormPageInputItemTextName,
  FormPageInputItemTextSingleLine,
  FormPageInputItemTextTel,
  TextPropertyAdditionalText,
  TextPropertyMultiLine,
  TextPropertyName,
  TextPropertySingleLine,
  TextPropertyTel,
  TEXT_PROPERTY_INPUT_TYPE,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { TextAdditionalText } from './TextAdditionalText';
import { TextMultiLine } from './TextMultiLine';
import { TextName } from './TextName';
import { TextSingleLine } from './TextSingleLine';
import { TextTel } from './TextTel';
import { TextInputProps } from './shared';

const isError = (
  errorMessages: TextInputProps['errorMessages'],
  displayError = false
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const TextInputExcludeZipCode: React.FC<TextInputProps> = (props) => {
  switch (props.property.inputFormat.inputType) {
    case TEXT_PROPERTY_INPUT_TYPE.singleLine: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          TextPropertySingleLine,
          FormPageInputItemTextSingleLine
        >;
      const displayError = submitted || (touched && touched.text);
      return (
        <TextSingleLine
          text={value.text}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case TEXT_PROPERTY_INPUT_TYPE.name: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          TextPropertyName,
          FormPageInputItemTextName
        >;
      const displayError =
        submitted || (touched && touched.firstName && touched.lastName);
      return (
        <TextName
          firstName={value.firstName}
          lastName={value.lastName}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case TEXT_PROPERTY_INPUT_TYPE.tel: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<TextPropertyTel, FormPageInputItemTextTel>;
      const displayError =
        submitted ||
        (touched && touched.first && touched.second && touched.third);
      return (
        <TextTel
          first={value.first}
          second={value.second}
          third={value.third}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case TEXT_PROPERTY_INPUT_TYPE.additionalText: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          TextPropertyAdditionalText,
          FormPageInputItemTextAdditionalText
        >;
      const displayError = submitted || (touched && touched.text);
      return (
        <TextAdditionalText
          text={value.text}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case TEXT_PROPERTY_INPUT_TYPE.multiLine: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          TextPropertyMultiLine,
          FormPageInputItemTextMultiLine
        >;
      const displayError = submitted || (touched && touched.text);
      return (
        <TextMultiLine
          text={value.text}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    default: {
      return null;
    }
  }
};
